import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import ScrollReveal from "scrollreveal"


import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";

import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: false,
          loop: true,
          nav: false,
          autoplayHoverPause: false,
          autoplay: true,
          autoplaySpeed: 1000,
          animateIn: "fadeIn",
          animateOut: "fadeOut",
          autoWidth: false,
          autoHeight: false,
          center: true,
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.c-block-image__image').owlCarousel({
          items: 1,
          margin: 0,
          dots: false,
          loop: true,
          nav: false,
          autoplayHoverPause: false,
          autoplay: true,
          autoplaySpeed: 500,
          animateIn: "fadeIn",
          animateOut: "fadeOut",
          autoWidth: false,
          autoHeight: false,
          center: true,
        });
      });
    }

    // modaal
    function modaal() {
      // ====================
      // <HTML>
      // <a href="path/to/image.jpg" class="js-modal-image" data-modaal-desc="My Description">Show</a>
      // or
      // <button data-modaal-content-source="path/to/image.jpg" class="js-modal-image">Show</button>
      // ====================

      $('.js-modal-image').modaal({
        type: 'image'
      });
    }

    function FixedHead() {
      if ($('#globalNavi').length <= 0) {
        return;
      }
      var offset_top = 0;
      var offset = $('#globalNavi').offset();

      if (offset !== undefined) {
        offset_top = offset.top;
      }
      // if (offset === undefined) {
      //   offset = $(".l-header-variable.is-main-visual").offset();
      //   if (offset !== undefined) {
      //     var height = $(".l-header-variable.is-main-visual").height()
      //     offset_top = offset.top + height;
      //   }
      // }
      $(window).scroll(function () {
        if ($(window).scrollTop() > offset_top) {
          $('#globalNavi').addClass('is-fixed');
          $('#Mainvisual').addClass('is-fixed');
          $('.c-breadcrumb').addClass('is-fixed');
        } else {
          $('#globalNavi').removeClass('is-fixed');
          $('#Mainvisual').removeClass('is-fixed');
          $('.c-breadcrumb').removeClass('is-fixed');
        }
      });
    }

    function scrollReaval() {
      //- スクロールリーバル
      window.sr = ScrollReveal({duration: 600});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      //top
      sr.reveal(".c-main-visual", {
        delay: 600,
        scale: 1,
        duration: 1200,
        origin: 'bottom',
        distance: '0',
      }, 100);

      sr.reveal(".l-page-header__inner", {
        delay: 200,
        scale: 1,
        duration: 500,
        origin: 'bottom',
        distance: '8px',
      }, 100);

      sr.reveal(".c-block-special__content", {
        delay: 400,
        scale: 1,
        duration: 800,
        origin: 'bottom',
        distance: '8px',
      }, 100);

      sr.reveal(".c-block-special__image", {
        delay: 400,
        scale: 1,
        duration: 800,
        origin: 'right',
        distance: '8px',
      }, 100);

      sr.reveal(".c-block-opening__title", {
        delay: 200,
        scale: 1,
        duration: 800,
        origin: 'bottom',
        distance: '8px',
      }, 100);

      sr.reveal(".c-block-opening__subtitle", {
        delay: 400,
        scale: 1,
        duration: 800,
        origin: 'bottom',
        distance: '8px',
      }, 100);

      //ScrollReveal().reveal('.c-block-opening__image',{
      //afterReveal: function (el){
      // el.classList.add('is-active');
      //}
      //});

      var blocks01 = $(".c-hero-block-center__block,.c-block-hero__block,.c-card-lg__inner,.c-block-cardlist,.c-block-image-lg,.c-box-interview,.c-card-simple__list .row,.c-box-graphics__list,.c-block-opening__text");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, duration: 500, delay: 600, origin: 'bottom', distance: '8px'}, 200);
        sr.reveal(item.children[1], {delay: 800, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[2], {delay: 1000, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[3], {delay: 1100, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[4], {delay: 1200, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[5], {delay: 1300, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[6], {delay: 1400, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[7], {delay: 1500, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[8], {delay: 1600, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[9], {delay: 1700, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[10], {delay: 1800, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[11], {delay: 1900, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[12], {delay: 2000, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[13], {delay: 2100, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);
      });
      var blocks02 = $(".c-block-slip__boxs");
      domEach(blocks02, function (key, item) {
        sr.reveal(item, {scale: 1, duration: 500, delay: 600, origin: 'bottom', distance: '8px'}, 200);
        sr.reveal(item.children[1], {delay: 800, scale: 1, duration: 500, origin: 'bottom', distance: '8px'}, 300);

      });

    }

    function SpMenu() {
      $('.c-slidebar-menu a').on('click', function () {
        $('body').removeClass('is-slidebar-active');
      });
    }

    function modalOriginal() {
      $(".c-card__block").modaal();
    }

    function UrlPara() {
      var url = location.serch;
      var param = location.search;
      if (document.URL.match(/Suria/)) {
        $('.c-tabs__navs li a').removeClass('is-active');
        $('.c-tabs__content').removeClass('is-active');
        $('.c-tabs__navs li a[data-tab-target="1"]').addClass('is-active');
        $('.c-tabs__content[data-tab-name="1"]').addClass('is-active');
      }
      // サブディレクトリからの移動の場合、ローディングはなし
      var ref = document.referrer;
      var hereHost = window.location.hostname;
      var protocol = window.location.protocol;
      var sStr = protocol + "//" + hereHost + "";
      console.log(sStr);
      var rExp = new RegExp(sStr, "i");
      if (ref.match(rExp)) {
        $('.c-loading').addClass('is-hidden');
      }
    }

    $(function () {
      menuSlide();
      owlCarousel();
      FixedHead();
      scrollReaval();
      SpMenu();
      modalOriginal();
      UrlPara();
    });
  }
}

window.GApp = new App();
